/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-01-30 13:05:28
 * @modify date 2022-01-30 13:05:28
 * @desc [description]
 */
import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'
import { ArrowCircleLeftOutlined } from '@mui/icons-material'
import {Box, Container, Stack, Typography} from '@mui/material'

import { useStyles } from './header-title.styles'
import { HeaderTitleProps } from './header-title.props'
import {isArray} from "lodash";

export const HeaderTitle: React.FC<HeaderTitleProps> = (props: HeaderTitleProps) => {
  const classes = useStyles()
  const { title, subtitle, backUrl, breadcrumb, rightContent, dataLinks, ...rest } = props

  return (
    <Container className={classes.wrapper} {...rest}>
      {isArray(dataLinks) ?
          <Stack direction="row" spacing={2} className={classes.linkWrapper}>
            {dataLinks.map(data => {
              return(
                <Box className={classes.linkWrapper}>
                  { data.backUrl && (
                    <Link to={data.backUrl} className={classes.link}>
                      <ArrowCircleLeftOutlined />
                    </Link>
                  )}
                  <Typography variant='body2'>
                    {data.breadcrumb}
                  </Typography>
                </Box>
              )
            })}
          </Stack>
        :
          <Box className={classes.linkWrapper}>
            { backUrl && (
              <Link to={backUrl} className={classes.link}>
                <ArrowCircleLeftOutlined />
              </Link>
            )}
            <Typography variant='body2'>
              {breadcrumb}
            </Typography>
          </Box>
      }
      <Box className={classes.titleWrapper}>
        <Box className={clsx(classes.title, rightContent && 'has-content')}>
          <Typography variant="h4" sx={{wordBreak: 'break-word', pr: 2}}>
            {title}
          </Typography>
          <Typography>
            {ReactHtmlParser(subtitle)}
          </Typography>
        </Box>
        {rightContent}
      </Box>
    </Container>
  )
}
